import { Formik } from 'formik';
import { toast } from 'react-toastify';
import { useGetSettingsQuery, useUpdateSettingsMutation } from './settings.api';
import { Card, CardContent } from 'shared-components';
import { TabBar } from 'shared-components';
import { PageTitle } from 'shared-components';
import { Route, Routes } from 'react-router-dom';
import { SettingsWatermark } from './settings-watermark';
import { SettingsStripe } from './settings-stripe';
import { SettingsThumbs } from './settings-thumbs';
import RouteList from '../../app/routes';
import { SettingsDesign } from './settings-design';
import { useEnsureAccountInfraMutation } from '../switch-account/accounts.api';
import { SettingsLicenses } from './settings-licenses';
import { SettingsNavigation } from './settings-navigation';
import { SettingsBilling } from './settings-billing';
import {
  DEFAULT_GALLERY_DESIGN,
  DEFAULT_GALLERY_DESIGN_LIGHT,
} from './settings.defaults';

export const Settings = () => {
  // const { data, isLoading, isFetching, refetch } = useGetWatermarkQuery();
  // const [deleteWatermark, { isLoading: isDeleting }] =
  //   useDeleteWatermarkMutation();
  const [updateSettings] = useUpdateSettingsMutation();

  const [ensureInfra] = useEnsureAccountInfraMutation();
  const { data: settings } = useGetSettingsQuery();
  // const dispatch = useAppDispatch();
  // const { getFieldProps, handleSubmit, submitForm } = useFormik<
  //   Partial<ISiteSettings>
  // >({
  //   initialValues: {},
  //   enableReinitialize: true,
  //   onSubmit: async (values) => {},
  // });
  return (
    <Formik
      initialValues={{
        stripePublishableKey: settings?.stripePublishableKey ?? '',
        stripeSecretKey: settings?.stripeSecretKey ?? '',
        thumbHeight: settings?.thumbHeight ?? 0,
        thumbWidth: settings?.thumbWidth ?? 0,
        logoLink: settings?.logoLink ?? '',
        topNavItems: settings?.topNavItems ?? [],
        galleryDesign: { ...DEFAULT_GALLERY_DESIGN, ...settings?.galleryDesign },
        separateLightDarkPalette: settings?.separateLightDarkPalette ?? false,
        galleryDesignLight: {
          ...DEFAULT_GALLERY_DESIGN_LIGHT,
          ...settings?.galleryDesignLight,
        },
        separateLightDarkLogo: settings?.separateLightDarkLogo ?? false,
      }}
      enableReinitialize={true}
      onSubmit={async (values) => {
        await updateSettings({
          data: values,
        });
        toast.success('Settings updated');
      }}
    >
      {({ submitForm, getFieldProps }) => (
        <>
          <PageTitle
            title="Settings"
            crumbs={[
              {
                display: RouteList.DASHBOARD.title,
                link: RouteList.DASHBOARD.link,
              },
              {
                display: RouteList.SETTINGS.title,
                link: RouteList.SETTINGS.link,
              },
            ]}
            allowSave={true}
            furtherActions={[
              {
                display: 'Ensure Infrastructure',
                value: 'reensure',
              },
            ]}
            onAction={async (action) => {
              switch (action) {
                case 'save':
                  submitForm();
                  break;
                case 'reensure':
                  await ensureInfra();
                  toast.success('Infrastructure ensured');
                  break;
              }
            }}
          />
          <Card>
            <CardContent>
              <TabBar
                tabs={[
                  { display: 'Watermark', link: '', endMatch: true },
                  { display: 'Stripe', link: 'stripe' },
                  { display: 'Thumbnails', link: 'thumbs' },
                  { display: 'Design', link: 'design' },
                  { display: 'Navigation', link: 'navigation' },
                  { display: 'Licenses', link: 'licenses' },
                  { display: 'Billing', link: 'billing' },
                ]}
              />
            </CardContent>

            <Routes>
              <Route index element={<SettingsWatermark />} />
              <Route path="stripe" element={<SettingsStripe />} />
              <Route path="thumbs" element={<SettingsThumbs />} />
              <Route path="design" element={<SettingsDesign />} />
              <Route path="navigation" element={<SettingsNavigation />} />
              <Route path="licenses" element={<SettingsLicenses />} />
              <Route path="billing" element={<SettingsBilling />} />
            </Routes>
          </Card>
        </>
      )}
    </Formik>
  );
};
